import { render, staticRenderFns } from "./Cookies-pl.vue?vue&type=template&id=0e07326c&"
import script from "./Cookies-pl.vue?vue&type=script&lang=js&"
export * from "./Cookies-pl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e07326c')) {
      api.createRecord('0e07326c', component.options)
    } else {
      api.reload('0e07326c', component.options)
    }
    module.hot.accept("./Cookies-pl.vue?vue&type=template&id=0e07326c&", function () {
      api.rerender('0e07326c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookies/Cookies-pl.vue"
export default component.exports